<script setup>
import {defineEmits, ref, watch} from 'vue';

    const props = defineProps({
        countries: Array,
        country_id: Number || null,
        modelValue: Number,
        placeholder: String || 'Select Country',
        selectClass: String || '',
    });

    const country = ref(props.modelValue);

    const emit = defineEmits([
        'update:modelValue',
    ]);

    watch(country, (newValue) => {
        emit('update:modelValue', newValue);
    });

    watch(() => props.modelValue, (newValue) => {
        country.value = newValue;
    });
</script>

<template>

    <select class="form-control select" :class="selectClass" v-model="country" :placeholder="placeholder">
        <option value="0" v-text="placeholder"></option>
        <option
            v-for="country in countries"
            :key="country.id"
            :value="country.id"
            v-text="country.country"
            :selected="country_id === country.id"
        ></option>

    </select>

</template>

<style scoped>

</style>
